module.exports = __webpack_public_path__ + "static/patima_afterparty-78deab4564abe885d8d3a22aeb5055b6.jpg";